"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _cases = _interopRequireDefault(require("../cases"));
var _referrals = _interopRequireDefault(require("../referrals"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function findStatusObject(enums, statuses, value) {
  var enumStatus = (0, _lodash.get)(enums, statuses, null);
  return (0, _lodash.find)(enumStatus, {
    value: value
  });
}
function pendingReferralStatus(referral) {
  return ['rejected', 'pending', 'unsent'].includes((0, _lodash.get)(referral, 'contact.consent.status'));
}
function useDashBoardStatuses(type, detailObj) {
  if (type === 'referrals' && _referrals["default"].isPendingReferral(detailObj)) {
    return pendingReferralStatus(detailObj);
  }
  return false;
}
function pendingReferralValue(referral) {
  var status = (0, _lodash.get)(referral, 'contact.consent.status');
  switch (status) {
    case 'rejected':
      return 'declined_consent';
    case 'unsent':
    case 'pending':
      return 'pending_consent';
    default:
      return (0, _lodash.get)(referral, 'status');
  }
}
function getReferralValue(referral) {
  if (_referrals["default"].isPendingReferral(referral)) {
    return pendingReferralValue(referral);
  }
  return (0, _lodash.get)(referral, 'status');
}
function getDetailObjValue(type, detailObj) {
  switch (type) {
    case 'service_cases':
      return _cases["default"].caseStatus(detailObj);
    case 'referrals':
      return getReferralValue(detailObj);
    default:
      return (0, _lodash.get)(detailObj, 'status');
  }
}

/**
 * @param { object } detailObj - examples include referrals, serviceCase, Assistance Request
 * @param { string } enumsKey - enums key to find the proper enums
 * @param { object } session - retrieved via state.session
 * @param { object } options - additional options specific to detailObj type
 * @return { object } - returns enums display_name and value
 */

function generateEnumsObject(detailObj, enumsKey, session) {
  var enumsObj = (0, _lodash.get)(session, "enums[".concat(enumsKey, "]"), null);
  var statuses = useDashBoardStatuses(enumsKey, detailObj) ? 'dashboard_statuses' : 'statuses';
  var value = getDetailObjValue(enumsKey, detailObj);
  return findStatusObject(enumsObj, statuses, value) || {};
}
var _default = exports["default"] = generateEnumsObject;